import React from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { SubscriptionProvider } from '../contexts/SubscriptionContext';

/**
 * Wraps children with SubscriptionProvider, passing Clerk auth details.
 * Place inside ClerkProvider but outside the components that need subscription state.
 */
const SubscriptionGate = ({ children }) => {
  const { getToken } = useAuth();
  const { user } = useUser();

  return (
    <SubscriptionProvider getToken={getToken} userId={user?.id}>
      {children}
    </SubscriptionProvider>
  );
};

export default SubscriptionGate;
